export default "__VITE_ASSET__2J53dim0__"